import React from 'react';
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, jobSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_JOBS_QUERY } from './queries';

/** Map tbl_post.status single-char codes to a human label. */
const statusLabel = (status: string | null | undefined): string | null => {
  if (status === 'O') return 'Open';
  if (status === 'C') return 'Closed';
  if (status === 'P') return 'Pending';
  return status ? String(status) : null;
};

const JobPicker: React.FC<{ element: DocumentElementType }> = ({ element }) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_JOBS_QUERY}
    collectionField="documentElementJobs"
    icon={faBriefcase}
    iconColour="#e58a1a"
    defaults={{
      label: 'Job',
      placeholder: 'Search for a job...',
    }}
    rowSubtitle={(row) =>
      (row.propertyName as string | null | undefined) || null
    }
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.refId) out.push(`#${row.refId}`);
      const s = statusLabel(row.status as string | null | undefined);
      if (s) out.push(s);
      if (row.customerName) out.push(String(row.customerName));
      return out;
    }}
    rowToSnapshot={jobSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.job].contextSpec}
  />
);

export default JobPicker;
